export const InternationalPhoneFormatPattern = /^\+[1-9]\d{7,14}$/;
